import mirror from 'keymirror';

export const actionTypes = mirror({
  PLANS_SET_SELECTED: null,
  PLANS_CLEAR_SELECTED: null,
});

export const clearSelectedPlan = () => async dispatch => {
  dispatch({
    type: actionTypes.PLANS_CLEAR_SELECTED,
  });
};

export const setSelectedPlan = selectedPlan => async dispatch => {
  dispatch({
    type: actionTypes.PLANS_SET_SELECTED,
    selectedPlan,
  });
};
